import { render, staticRenderFns } from "./home-bb-new.vue?vue&type=template&id=83b59ba8&scoped=true"
import script from "./home-bb-new.vue?vue&type=script&lang=js"
export * from "./home-bb-new.vue?vue&type=script&lang=js"
import style0 from "./home-bb-new.vue?vue&type=style&index=0&id=83b59ba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b59ba8",
  null
  
)

export default component.exports